import React from 'react';

export interface MasIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const MasIcon: React.FC<MasIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.01v16.971m-8.485-8.485h16.97"/>
    </svg>
  );
};

export default MasIcon;
